import { createRouter, createWebHistory } from 'vue-router'

import Bounty from '../views/Bounty.vue'
import Claim from '../views/Claim.vue'
import Congrats from '../views/Congrats.vue'
import Disclaimer from '../views/Disclaimer.vue'
import GetStarted from '../views/GetStarted.vue'
import Leaders from '../views/Leaders.vue'
import MyCollection from '../views/MyCollection.vue'
import PPWeapon from '../views/PPWeapon.vue'
import Privacy from '../views/Privacy.vue'
import Stats from '../views/Stats.vue'
import Terms from '../views/Terms.vue'
import ViewCollection from '../views/ViewCollection.vue'
// import EpicSets from '../views/EpicSets.vue'
// import Market from '../views/Market.vue'
// import About from '../views/About.vue'
// import ReferEarn from '../views/ReferEarn.vue'
// import Unique from '../views/Unique.vue'
// import ViewTrade from '../views/ViewTrade.vue'

const titleTemplate = `PixelPower |`
const defaultImage =
  'https://pixelgames.mypinata.cloud/ipfs/QmVHAxB2cwy1jUbaKMziRQk4LBuxQo1oD9zZooy2g2BaeB'

const makeRoute = (path, name, component, image = defaultImage) => {
  const strippedPath = path.substring(1)
  return {
    path: path,
    name: name,
    component: component,
    meta: {
      title: `${titleTemplate} ${name}`,
      metaTags: [
        {
          name: 'description',
          content:
            'PixelPower is a high-caliber NFT competition built on the tezos blockchain. Players compete to collect 50+ NFT weapons with 6 levels of rarity, build their firepower and earn rewards.',
        },
        {
          property: 'og:description',
          content:
            'PixelPower is a high-caliber NFT competition built on the tezos blockchain. Players compete to collect 50+ NFT weapons with 6 levels of rarity, build their firepower and earn rewards.',
          id: 'ogDesc',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:url',
          content: `${process.env.BASE_URL}${strippedPath}`,
          id: 'ogUrl',
        },
        {
          property: 'og:image',
          content: `${image}`,
          id: 'ogImg',
        },
        {
          property: 'og:title',
          content: `${titleTemplate} ${name}`,
        },
      ],
    },
  }
}

const routes = [
  makeRoute('/', 'Home', GetStarted),
  makeRoute('/bounty', 'Bounty Hunter', Bounty),
  makeRoute('/me', 'My Collection', MyCollection),
  makeRoute('/claim', 'Claim', Claim),
  makeRoute('/stats', 'Stats', Stats),
  makeRoute('/leaders', 'Leaders', Leaders),
  makeRoute('/token/:tokenId', 'Token', PPWeapon),
  makeRoute('/collection/:owner', 'ViewCollection', ViewCollection),
  makeRoute('/congrats', 'Congrats', Congrats),
  makeRoute('/disclaimer', 'Disclaimer', Disclaimer),
  makeRoute('/terms', 'Terms', Terms),
  makeRoute('/privacy', 'Privacy', Privacy),
  // makeRoute('/about', 'About', About),
  // makeRoute('/market', 'Market', Market),
  // makeRoute('/refer', 'Refer & Earn', ReferEarn),
  // makeRoute('/uniques', 'Unique', Unique),
  // makeRoute('/trades/:tradeId', 'ViewTrade', ViewTrade),
  // makeRoute('/epic', 'Epic Sets', EpicSets),
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkExactActiveClass: 'underline text-gray-900',
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag))

  next()
})

export default router
